(function () {
  if (window.MMKlaviyo) return;

  const ENDPOINT = 'https://a.klaviyo.com/client/subscriptions/';
  const REVISION = '2024-10-15';

  function subscribe(options) {
    const profileAttributes = { email: options.email };
    if (options.firstName) profileAttributes.first_name = options.firstName;

    const payload = {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: profileAttributes,
            },
          },
        },
        relationships: {
          list: {
            data: { type: 'list', id: options.listId },
          },
        },
      },
    };

    if (options.source) {
      payload.data.attributes.custom_source = options.source;
    }

    const url = ENDPOINT + '?company_id=' + encodeURIComponent(options.companyId);

    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        revision: REVISION,
      },
      body: JSON.stringify(payload),
      // Lets the request finish if the page navigates (native form posts).
      keepalive: true,
    }).then(function (response) {
      if (!response.ok) throw new Error('Klaviyo responded with ' + response.status);
      return response;
    });
  }

  window.MMKlaviyo = { subscribe: subscribe };

  function messageClass(messageEl, state) {
    return (messageEl.dataset.klaviyoMessage || '') + '--' + state;
  }

  function showMessage(messageEl, text, state) {
    if (!messageEl || !text) return;

    messageEl.textContent = text;
    messageEl.classList.toggle(messageClass(messageEl, 'success'), state === 'success');
    messageEl.classList.toggle(messageClass(messageEl, 'error'), state === 'error');
    messageEl.hidden = false;
  }

  function hideMessage(messageEl) {
    if (!messageEl) return;

    messageEl.hidden = true;
    messageEl.textContent = '';
    messageEl.classList.remove(messageClass(messageEl, 'success'), messageClass(messageEl, 'error'));
  }

  function readFields(form) {
    const emailInput = form.querySelector('input[type="email"]');
    const nameInput = form.querySelector('input[name="contact[first_name]"]');

    return {
      email: emailInput ? emailInput.value.trim() : '',
      firstName: nameInput ? nameInput.value.trim() : '',
    };
  }

  function initNativeForm(root, form) {
    let lastEmail = '';

    form.addEventListener('submit', function () {
      if (!form.checkValidity()) return;

      const fields = readFields(form);
      if (!fields.email || fields.email === lastEmail) return;
      lastEmail = fields.email;

      subscribe({
        companyId: root.dataset.klaviyoCompanyId,
        listId: root.dataset.klaviyoListId,
        email: fields.email,
        firstName: fields.firstName,
        source: root.dataset.klaviyoSource,
      }).catch(function (error) {
        console.error('[mm-klaviyo] subscribe error', error);
      });
    });
  }

  function initAjaxForm(root, form) {
    const messageEl = form.querySelector('[data-klaviyo-message]');
    const submitButton = form.querySelector('[type="submit"]');

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      if (!form.reportValidity()) return;

      const fields = readFields(form);
      if (!fields.email) return;

      hideMessage(messageEl);
      if (submitButton) submitButton.disabled = true;
      form.setAttribute('aria-busy', 'true');

      subscribe({
        companyId: root.dataset.klaviyoCompanyId,
        listId: root.dataset.klaviyoListId,
        email: fields.email,
        firstName: fields.firstName,
        source: root.dataset.klaviyoSource,
      })
        .then(function () {
          showMessage(messageEl, root.dataset.klaviyoSuccessMessage, 'success');
          form.reset();
        })
        .catch(function (error) {
          console.error('[mm-klaviyo] subscribe error', error);
          showMessage(
            messageEl,
            root.dataset.klaviyoErrorMessage || 'Something went wrong. Please try again.',
            'error'
          );
        })
        .then(function () {
          if (submitButton) submitButton.disabled = false;
          form.removeAttribute('aria-busy');
        });
    });
  }

  function initForm(root) {
    const form = root.querySelector('form');

    if (!root.dataset.klaviyoCompanyId || !root.dataset.klaviyoListId) return;
    if (!form || form.dataset.klaviyoBound) return;
    form.dataset.klaviyoBound = 'true';

    if (root.dataset.klaviyoMode === 'ajax') {
      initAjaxForm(root, form);
    } else {
      initNativeForm(root, form);
    }
  }

  function initWithin(root) {
    root.querySelectorAll('[data-mm-klaviyo]').forEach(initForm);
  }

  function init() {
    initWithin(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initWithin(event.target);
  });
})();
